import React, { useEffect, useRef, useState } from "react";
import ConversationItem from "components/ConversationItem/ConversationItem";

import "./Stock.scss";
import { useSocket, wsEvents } from "../../../../../hooks/useSocket";
import { useGetStock } from "../../../../../services/hooks/useGetStock";
import { LoadingOutlined } from "@ant-design/icons";

const Stock = () => {
  const stockListRef = useRef();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchString = urlParams.get("search");
  const [stock, setStock] = useState([]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isInitialLoading,
    refetch,
  } = useGetStock(searchString);
  useSocket({
    type: wsEvents.CLAIMED,
    callBack: (payload) => {
      setStock((current) => {
        return current.map((obj) => {
          if (obj.id === payload.conversation) {
            return {
              ...obj,
              claimable: false,
            };
          }
          return obj;
        });
      });
    },
  });
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    setStock(data?.pages.map((item) => item.data).flat());
  }, [data]);
  useEffect(() => {
    const element = stockListRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [stockListRef, hasNextPage]);

  const handleScroll = () => {
    const element = stockListRef.current;
    if (element) {
      const { scrollHeight, clientHeight, scrollTop } = element;
      console.log({ scrollHeight, clientHeight, scrollTop });
      if (
        scrollHeight - clientHeight === Math.ceil(scrollTop) ||
        scrollHeight - clientHeight === Math.floor(scrollTop)
      ) {
        hasNextPage && fetchNextPage();
      }
    }
  };

  return (
    <div className="StockList" ref={stockListRef}>
      {stock?.map((item) => {
        return (
          <ConversationItem
            conversationData={item}
            key={item.id}
            buttonType="claim"
          />
        );
      })}
      <div
        style={{
          height: 60,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isFetching && <LoadingOutlined style={{ fontSize: 24 }} spin />}
        {!hasNextPage && !isInitialLoading && (
          <span>All conversations loaded</span>
        )}
      </div>
    </div>
  );
};

export default Stock;
